/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useState, useContext } from 'react';
import { IonModal, IonButtons, IonHeader, IonToolbar, IonTitle, IonButton, IonIcon, IonContent } from '@ionic/react';
import { close } from 'ionicons/icons';
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, } from '@chakra-ui/react';
import { Ionic, UXComponent, Web } from '../../components/UXComponent';
const store = createContext({ state: {}, setState: () => null });
const { Provider } = store;
const ModalProvider = (props) => {
    const [state, setState] = useState({});
    return (React.createElement(Provider, { value: { state, setState } }, props.forceIonic === true ? (React.createElement(React.Fragment, null,
        React.createElement(IonModal, { isOpen: state.show || false, onDidDismiss: () => {
                setState({ show: false });
            } },
            React.createElement(IonHeader, null, state.header ?
                state.header
                :
                    React.createElement(IonToolbar, { color: state.color || 'primary', mode: "ios" },
                        React.createElement(IonButtons, { slot: "start" },
                            React.createElement(IonButton, { onClick: () => setState({ show: false }) },
                                React.createElement(IonIcon, { icon: close, slot: "icon-only" }))),
                        React.createElement(IonTitle, null, state.title))),
            React.createElement(IonContent, null, state.body ? state.body : undefined)),
        props.children)) : (React.createElement(UXComponent, null,
        React.createElement(Ionic, null,
            React.createElement(React.Fragment, null,
                React.createElement(IonModal, { isOpen: state.show || false, onDidDismiss: () => {
                        setState({ show: false });
                    } },
                    React.createElement(IonHeader, null, state.header ?
                        state.header
                        :
                            React.createElement(IonToolbar, { color: state.color || 'primary', mode: "ios" },
                                React.createElement(IonButtons, { slot: "start" },
                                    React.createElement(IonButton, { onClick: () => setState({ show: false }) },
                                        React.createElement(IonIcon, { icon: close, slot: "icon-only" }))),
                                React.createElement(IonTitle, null, state.title))),
                    React.createElement(IonContent, null, state.body ? state.body : undefined)),
                props.children)),
        React.createElement(Web, null,
            React.createElement(Modal, { isOpen: state.show || false, onClose: () => {
                    setState({ show: false });
                } },
                React.createElement(ModalOverlay, null),
                React.createElement(ModalContent, null,
                    React.createElement(ModalHeader, null, state.header || state.title || undefined),
                    React.createElement(ModalCloseButton, null),
                    React.createElement(ModalBody, null, state.body ? state.body : undefined),
                    state.footer && React.createElement(ModalFooter, null, state.footer ? state.footer : undefined))),
            props.children)))));
};
function useModal() {
    const modalContext = useContext(store);
    const showModal = (props) => {
        modalContext.setState(Object.assign(Object.assign({}, props), { show: true }));
    };
    const hideModal = () => {
        modalContext.setState({ show: false });
    };
    return {
        showModal: showModal,
        hideModal: hideModal,
    };
}
export { store as ModalStore, ModalProvider, useModal };
//# sourceMappingURL=index.js.map